



















import Vue, { PropType } from 'vue'
import Address from '@/types/Address.interface'
import AddressBlock from '@/components/AddressBlock.vue'
import Person from '@/types/Person.interface'
export default Vue.extend({
    components: { AddressBlock },
    props: {
        readonly: {
            type: Boolean,
            default: false
        },
        person: {
            type: Object as PropType<Person>,
            required: true
        }
    },
    computed: {
        //  Determine is the current authenticated user is an 'operator'
        operator(): boolean {
            //  Grab our current role
            const role = this.$store.getters.userRole(this.$store.getters.user)

            //  Check if this role is an operator
            return window.getProps(role, ['name']) === 'Operator'
        }
    },
    methods: {
        //  Pop the edit address form dialog
        popEditAddressForm(address: Address, path: string): void {
            //  Get the address inputs
            const inputs = this.$store.getters.addressInputs(address)

            //  Pop an app form with the address inputs
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: `Edit Address`,
                icon: 'mdi-home',
                component: 'app-form',
                overflow: 'auto',
                props: { model: address, inputs: inputs },
                callback: (address: Address) => {
                    //  Close the app dialog
                    this.$store.dispatch('dialogClose', 'APP')

                    //  Update the selected person
                    this.person[path] = address

                    // We trigger our submit listener in PersonProfile.vue to save the changes automatically for the address change
                    // We do this becuase our pop-up says save
                    this.$emit('submit')
                }
            })
        },
        //  Pop a new address form dialog
        popNewAddressForm(path: string): void {
            //  Determine if this is a default billing or shipping address
            const default_billing = path === 'address_billing' ? 1 : 0
            const default_shipping = path === 'address_shipping' ? 1 : 0

            //  Create a new address
            const address = {
                city: null,
                country: null,
                country_code: null,
                country_subdivision: null,
                default_billing: default_billing,
                default_shipping: default_shipping,
                line1: null,
                line2: null,
                person_id: this.person.id,
                postalcode: null,
                postalcode_suffix: null
            }

            //  Get the address inputs
            const inputs = this.$store.getters.addressInputs(address)

            //  Pop an app form with the address inputs
            this.$store.dispatch('dialogOpen', {
                type: 'APP',
                title: `New Address`,
                icon: 'mdi-home',
                component: 'app-form',
                overflow: 'auto',
                props: { model: address, inputs: inputs },
                callback: (address: Address) => {
                    //  Close the app dialog
                    this.$store.dispatch('dialogClose', 'APP')

                    //  Update the selected person
                    this.$set(this.person[path], address)
                }
            })
        }
    }
})
